import request from '@/utils/request';

export function addScheduleData(data) {
  return request({
    url: '/yy/add_schedule_data',
    method: 'post',
    data
  });
}

export function readScheduleData(data) {
  return request({
    url: '/yy/read_schedule_data',
    method: 'post',
    data
  });
}

export function updateScheduleData(data) {
  return request({
    url: '/yy/update_schedule_data',
    method: 'post',
    data
  });
}

export function updateScheduleDataByName(data) {
  return request({
    url: '/yy/update_schedule_data_by_name',
    method: 'post',
    data
  });
}

export function delScheduleData(data) {
  return request({
    url: '/yy/del_schedule_data',
    method: 'post',
    data
  });
}